import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateSearchQuery } from "../../store/slices/tableSlice";
import {
  SearchBar,
  Pagination,
  TableItemsQuestionsCategory,
} from "../../components";
import { closeModal } from "../../store/slices/deleteModalSlice";
import "react-toastify/dist/ReactToastify.css";
import AddModalQuestionCategory from "../Modals/AddModalQuestionCategory";
import {
  fetchDataQuestionCategory,
  setPage,
} from "../../store/slices/apiQuestionCategorySlice";
import TableItemsQuestionsCategoryResponsive from "../TableItemsQuestionsCategory/TableItemsQuestionsCategoryResponsive";

const TableQuestionsCategory = () => {
  const dispatch = useDispatch();
  const loadinUpdate = useSelector(
    (state) => state.apiQuestionCategory.loadingUpdate
  );
  const loading = useSelector(
    (state) => state.apiQuestionCategory.loadinCreate
  );

  const backendBaseUrl = "https://back2.autoshkollaime.com";
  const dataQuestionCategory = useSelector(
    (state) => state.apiQuestionCategory.data
  );
  const [searchInput, setSearchInput] = useState("");

  const currentPage = useSelector(
    (state) => state.apiQuestionCategory.currentPage
  );
  const totalCount = useSelector(
    (state) => state.apiQuestionCategory.totalCount
  );
  const prevSearchRef = useRef("");


  useEffect(() => {
    const pageToUse = prevSearchRef.current !== searchInput ? 1 : currentPage;
  
    if (prevSearchRef.current !== searchInput) {
      dispatch(setPage(1));
      prevSearchRef.current = searchInput;
    }
  
    dispatch(fetchDataQuestionCategory({ page: pageToUse, searchQuery: searchInput }));
  }, [dispatch, currentPage, searchInput]);
  

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(
      fetchDataQuestionCategory({ page: currentPage, searchQuery: searchInput })
    );
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  useEffect(() => {
    dispatch(fetchDataQuestionCategory({ page: currentPage, searchQuery: searchInput }));
  }, [dispatch, loadinUpdate, loading]);
  

  return (
    <div className="p-3">
      <div className="flex flex-col sm:flex-row items-center justify-between pb-4 bg-white dark:bg-gray-900 gap-3 sm:gap-0">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
          className="w-full sm:w-auto"
        />
        <div>
          <button className="text-danger mx-2" alt="you can edit here">
            <AddModalQuestionCategory
              title="Shto një pyetje me kategori"
              submitButtonText="Shto pyetjen"
              onCancel={handleCloseModal}
              nameQuestionCategory="Emri i Pyetjes me Kategori"
              categoryQuestionCategory="Zgjedh kategorinë e pyetjes"
              photoQuestionCategory="Shto ikonën"
              premiumStatus="Premium"
            />
          </button>
        </div>
      </div>

      <div
        className="relative overflow-x-auto shadow-md sm:rounded-lg"
        style={{ borderRadius: 1 }}
      >
        <div className="hidden sm:block">
          <table className="w-full min-w-[600px] text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-4 py-3">
                  Emri i Pyetjes
                </th>
                <th scope="col" className="px-4 py-3">
                  Kategoria
                </th>
                <th scope="col" className="px-4 py-3">
                  Ikona
                </th>
                <th scope="col" className="px-4 py-3">
                  Premium
                </th>
                <th scope="col" className="px-4 py-3">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <TableItemsQuestionsCategory
                dataQuestionCategory={dataQuestionCategory}
                baseUrl={backendBaseUrl}
              />
            </tbody>
          </table>
        </div>

        <div className="block sm:hidden space-y-4">
          <TableItemsQuestionsCategoryResponsive
            dataQuestionCategory={dataQuestionCategory}
            baseUrl={backendBaseUrl}
          />
        </div>

        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default TableQuestionsCategory;
